import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query'
import { LeadDtoFilterKey } from 'api/Clients/Types/LeadDto'
import { BuildQueryProps } from 'utils/QueryHelpers'

export const normalizeLeadsSearchQuery = (
  filterDescriptor: FilterDescriptor[] | CompositeFilterDescriptor
): BuildQueryProps => {
  const gridFilterDescriptor = filterDescriptor as CompositeFilterDescriptor
  const filters = gridFilterDescriptor.filters.map(
    (x: FilterDescriptor | CompositeFilterDescriptor) => {
      const filterItem = x as FilterDescriptor

      if (filterItem.field === LeadDtoFilterKey.converted) {
        const value: boolean = filterItem?.value
        return {
          ...filterItem,
          value: value?.toString() ?? value,
        }
      }

      return filterItem
    }
  )

  return { ...gridFilterDescriptor, filters }
}
